import { computed, reactive, readonly } from "vue";
import { api, type Item } from "../api";

export function allows(user: Item | null | undefined, permission: string) {
  const granted = (user?.permissions as string[] | undefined) ?? [];
  if (!permission || granted.includes("*") || granted.includes(permission)) return true;
  return permission === "file.read" && granted.includes("file.write");
}

const state = reactive({
  ready: false,
  user: null as Item | null
});

export function useAuth() {
  async function restore() {
    try { state.user = await api.get<Item>("/me"); }
    catch { state.user = null; }
    finally { state.ready = true; }
    return state.user;
  }
  async function loginWithCode(code: string) {
    const result = await api.post<{ user?: Item; totpRequired?: boolean; challenge?: string }>("/login/code", { code });
    if (result.user) {
      state.user = result.user;
      state.ready = true;
    }
    return result;
  }
  async function login(username: string, password: string) {
    const result = await api.post<{ user?: Item; totpRequired?: boolean; challenge?: string }>("/login", { username, password });
    if (result.user) {
      state.user = result.user;
      state.ready = true;
    }
    return result;
  }
  async function confirmTotp(challenge: string, code: string) {
    const result = await api.post<{ user: Item }>("/login/totp", { challenge, code });
    state.user = result.user;
    state.ready = true;
    return result.user;
  }
  async function logout() {
    await api.post("/logout", {});
    state.user = null;
  }
  return {
    state: readonly(state),
    signedIn: computed(() => Boolean(state.user)),
    restore, login, loginWithCode, confirmTotp, logout
  };
}
